import React, { useEffect, useState, useRef } from 'react'; 

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4'; 

const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Stock_data = async (params) => {

    const response = await fetch(`${process.env.REACT_APP_URL_MIS}/api/Fps_Day_Month_Trans_Details`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Truck_ro_recive_m_y_rep = ({month,year,fps_id,status,heading }) => {

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50); 



 const [totals, setTotals] = useState([]);
 
  const calculateTotals = (data) => {
    const columnCount = data[0].comodityData.length;
    const columnTotals = new Array(columnCount).fill(0); // Initialize an array for totals

    data.forEach(item => {
        item.comodityData.forEach((colItem, colIndex) => {
            columnTotals[colIndex] += parseFloat(colItem.allotqt) ||0; 
        });
    });

    setTotals(columnTotals); // Set the totals in state
};


const S_totals = reportData.reduce(
  (acc, item) => {
     acc.amount_all += item.amount || 0;
    return acc;
  },
  {
    amount_all: 0,
  }
);
    
    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Stock_data({month,year,fps_id,status,heading });
               // console.log(response_data)
                setTabHeading(response_data.heading);  
                if ( response_data.data.length > 0) {
                    setReportData(response_data.data);

                    calculateTotals(response_data.data); 


                   // console.log(response_data.data +"....in ");
               
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [month,year,fps_id,status,heading]);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
      const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
        setPage(0); // Reset page to 0 when changing rows per page
      };
      
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [ reportData]);

    if (loading) {
        
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }
     if (error) {
        console.log(error);
        return <div className="mainhead" align="center">Internal Error</div>;
    }
    // if (reportData.length === 0) {
    //     return <div className="mainhead" align="center">No data found</div>;
    // }
     
       if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
    return <div className="mainhead" align="center">
        No data found
    </div>
}
   
  const paginatedData = rowsPerPage === 'all' 
  ? reportData 
  : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <> 
            <table align="center" width="85%" border={1} id="">
                <thead>
                    <tr className="tableheader">
                        <th colSpan={10 + reportData[0].comodityData.length}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                      <th rowSpan={2}>Sl.No</th>
                      <th rowSpan={2}>RC No</th>
                      <th rowSpan={2}>Scheme</th>
                      <th rowSpan={2}>Avail Type</th>
                      <th rowSpan={2}>Receipt No</th> 
                      <th rowspan={2}>Date</th>

                     
                            <th colSpan={reportData[0].comodityData.length}  >
                            Commodity
                            </th>


                            <th rowspan={2}>Amount<br />(Rs.)	</th>

                             <th rowspan={2}>Portability</th>

{/*     <!--  <th rowspan={2}>Trans <br/>Type</th> -->  */     }
                          <th rowspan={2}>Auth Trans Time</th>


                            </tr> 

                            <tr className="tableheader">
                        {reportData[0].comodityData.map((item, index) => (
                            <th key={index}>{item.comm_name_en} <br></br></th>
                        ))}

                    </tr>

                   
                </thead>
                <tbody>
                    {paginatedData.map((item, index) => (
                      /*

                      <tr 
  key={item.fps_id} 
  style={{ 
    backgroundColor: 
      item.trans_status === "Partial Offline" ? "#cc6699" : 
      item.trans_status === "Manual" ? "#5c85d6" : 
      item.trans_status === "Offline" ? "#CC6479" : "white"
  }}
>


                      */
                      /*  <tr key={item.fps_id}> */



                      <tr  
                      key={item.fps_id} 
                      style={{  
                        backgroundColor: 
                          item.trans_status === "Partial Offline" ? "#cc6699" : 
                          item.trans_status === "Manual" ? "#5c85d6" : 
                          item.trans_status === "Offline" ? "#CC6479" : "white"
                      }}
                    >
                                          <td style={{ textAlign: 'center' , backgroundColor:'white'}}>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td> {/* Adjusted Sl.No */}

                            <td style={{ textAlign: 'left' }}>
                                    {item.existing_rc_number}

                            </td>
                            <td style={{ textAlign: 'right',  whiteSpace: 'nowrap' }}>{item.scheme_short_name}</td>
                            <td style={{ textAlign: 'right' }}>{item.trans_status}</td>
                            <td style={{ textAlign: 'right' }}>{item.receipt_id}</td>
                            <td style={{ textAlign: 'right' , whiteSpace: 'nowrap' }}>{item.login_time}</td>


                            {item.comodityData.map((item1, index) => (
                                <td style={{ textAlign: 'right' }} key={index}>{item1.allotqt.toFixed(3)}</td>
                            ))}

                         
                            
                            <td style={{textAlign : 'right' ,  whiteSpace: 'nowrap'}}>{item.amount.toFixed(2)}</td> 
                            <td style={{textAlign : 'right' ,  whiteSpace: 'nowrap'}}>{item.port_check}</td>
                            <td style={{textAlign : 'right' ,  whiteSpace: 'nowrap'}}>{item.trans_time}</td>
                        </tr>
                    ))}
                </tbody>


                <tfoot>
                    <tr className="tableheader">
                        <td colSpan={6}>Total</td>

                        {totals.map((total, index) => (
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>{total.toFixed(3)}</td>
                        ))}

                       
                                               <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{S_totals.amount_all}</td>

                      <td colSpan={2}></td>

                    </tr>
                </tfoot>
               
    
            </table>
            <br /><br />

            <div width="75%" style={{display:'flex', justifyContent:'right',alignItems:'start' , width:'95%'}}> 
      <PaginationTable
        count={reportData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /></div>
      <br></br>
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>    
            
      </>
    );
};
export default Truck_ro_recive_m_y_rep;




